<template>
	<div class="flex-wrapper">
		<TypographyTitle :level="2" class="flex-grow">
			{{ $t('activation-required.header') }}
		</TypographyTitle>
		<Button @click="onLogout">
			<LogoutOutlined /> {{ $t('account.logoutButtonLabel') }}
		</Button>
	</div>

	<div class="form-background max-width-750">
		<TypographyParagraph class="no-mg">
			{{ $t('activation-required.message') }}
		</TypographyParagraph>
		<TypographyParagraph class="no-mg">
			{{ $t('activation-required.problemsMessage') }}
		</TypographyParagraph>
		<div class="flex-wrapper pd-top-lg">
			<div class="flex-grow"></div>
			<Button :disabled="!done || isLoading" @click="resendEmail()">{{ minutesLeftDisplay }}</Button>
		</div>
	</div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { TypographyTitle, TypographyParagraph, Button, message } from 'ant-design-vue';
import { LogoutOutlined } from '@ant-design/icons-vue';

import { useI18n } from 'vue-i18n'

import Api from '@/api/Api';

import { showErrorMessage } from '@/components/common/errorMessage';

import { useLogout } from '@/components/account/useLogout';
import { useTimer } from '@/utils/useTimer';

export default {
	components: {
		TypographyTitle, TypographyParagraph, Button,
		LogoutOutlined,
	},
	setup() {
		const { t } = useI18n();
		const { onLogout } = useLogout();
		const isLoading = ref(false);
		const { done, minutesLeftDisplay, reset } = useTimer(5 * 60, 'activation-required.waitResendButtonLabel');
		const resendEmail = () => {
			isLoading.value = true;
			Api.resendActivationEmail(response => {
				isLoading.value = false;
				if (response.status === 'ok') {
					reset();
					message.success(t('activation-required.resendSuccess'));
				} else {
					showErrorMessage(response.errors);
				}
			});
		}
		onMounted(() => Api.getActivationEmailCooldown(response => {
			if (response.status === 'ok') {
				reset(response.seconds);
			}
		}));
		return {
			isLoading,
			done,
			minutesLeftDisplay,
			onLogout,
			resendEmail,
		};
	}
}
</script>
